import React, { useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from "../useAuthhandling";
import Toastmodal from "../Toastmodal";

function Banner() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  let navigate = useNavigate();

  const [banner , setBanner] = useState({
     title :"" ,
      file:"",
      status:'',
      fileType:''
 });

 const [toastmodal, setToastmodal] = useState(false);
 const [toastmessage, setToastmessage] = useState("");
 const [toasttype, setToasttype] = useState("");
 const [toastlarge, setToastlarge] = useState(false);

 const [formerror, setError] = useState({});

let name , value;

const  handleInputs = (e) =>{
     name = e.target.name;
     value = e.target.value;
     setBanner({...banner,[name]:value});
 } 
 
 const onFileChange = (e)=>{
   let name = e.target.name;
   setBanner({ ...banner,[name]: e.target.files[0] });
 };

 const validate = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = "Title name is required!";
  }

  if (!values.fileType) {
    errors.fileType = "File type is required!";
  }
  if (!values.status) {
    errors.status = "status is required!";
  } 
  if (!values.file) {
    errors.file = "File is required!";
  } 
  else{
  if(values.fileType==='image'){
    
      if (
        values.file.type === "image/jpeg" ||
        values.file.type === "image/jpg" ||
        values.file.type === "image/png" ||
        values.file.type === "image/webp" 
      ) {
        if (values.file.size > 1024 * 1000) {
          errors.file =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.file = "Only support jpg, jpeg, png, webp image!";
      }
    }
  
  }

  return errors;
};

 const PostData = async (e) => {
   e.preventDefault();
   const ress = validate(banner);
   setError(ress);

   const formData = new FormData();
   formData.append("title",banner.title);
   formData.append("fileType",banner.fileType);
   formData.append("status",banner.status);
  formData.append("file",banner.file);
  axios
  .post(`${Config.apiurl}/api/v1/crm/banner/create`, formData,{}).then((res) => {
     if (res.status === 200 ){
      setToastmodal(true);
      setToastmessage("Sucessfully Created banner");
      setToasttype("success");
      setToastlarge(false);
      setTimeout(() => navigate("/dashboard"), 3000);

     }
     else if(res.status === 401){
      handleUnauthorized();
      PostData();
    }
     else {
      setToastmodal(true);
      setToastmessage("Something went wrong!");
      setToasttype("error");
      setToastlarge(false);
     }
   });
 };

     return(
      <div>
        <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Banner</h4>
                        <p className="card-description">Add New Banner</p>
                        <form className="forms-sample" onSubmit={PostData}>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Title"
                              name="title"
                              value={banner.title}
                              onChange={handleInputs}
                            />
                               <label style={{ color: "red" }}>{formerror.title}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Type</label>
                           <select className="form-select" name="fileType" value={banner.fileType} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value='image'>Image</option>
                            <option value='video'>Video</option>
                           </select>
                           <label style={{ color: "red" }}>{formerror.fileType}</label>
                          </div>
                          
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">File</label>
                            <br></br>
                            <input type="file" name="file" onChange={onFileChange} />
                            <label style={{ color: "red" }}>{formerror.file}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Status</label>
                            <select className="form-select" name="status" value={banner.status} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>

                           </select>
                           <label style={{ color: "red" }}>{formerror.status}</label>
                          </div>
                          <button
                            type="submit"
                            onClick={PostData}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>

                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
      </div>
    );
  }


export default Banner;
